import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { emailWithdraw, getUserdata } from "../../Redux/Action";
import { setLocalStorageItem } from "../../Utils/Helper";

export const WithdrawCrypto = ({
  isWithdrawCryptoOpen,
  setIsWithdrawCryptoOpen,
  amount,
  setAmount,
  setFinalBalance,
  setRefresh
}) => {
  const userData = useSelector((state) => state?.Login?.userData);

  const dispatch = useDispatch();

  const [formData, setFormData] = useState({
    walletAddress: "",
    chain: "TRC20",
    amount,
    moneyPlantAccountNo: userData?.accountno,
    method: "crypto",
    role :userData?.role
  });

  const [errors, setErrors] = useState({});
  const [showConfirmModal, setShowConfirmModal] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    const cleanedValue = name === "amount" ? value.replace(/[^0-9]/g, "") : value;

    setFormData((prev) => ({ ...prev, [name]: cleanedValue }));
    if (name === "amount") setAmount(cleanedValue);
    setErrors((prev) => ({ ...prev, [name]: "" }));
  };

  const validateFields = () => {
    const newErrors = {};
    if (!formData.walletAddress.trim()) newErrors.walletAddress = "This field is required";
    // Check if amount is a string before calling trim, otherwise just check if it's falsy
    if (typeof formData.amount === 'string' ? !formData.amount.trim() : !formData.amount) {
      newErrors.amount = "This field is required";
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validateFields()) {
      setShowConfirmModal(true);
    }
  };

  const handleFinalSubmit = (saveAccount) => {
    const payload = {
      ...formData,
      ...(saveAccount && { saveAccount: true }),
    };
    dispatch(
      emailWithdraw({
        payload,
        callback: (data) => {
          if (data?.meta?.code === 200 && !isNaN(Number(data?.data?.newBalance))) {
            console.log("inside the callback true")
            // Just refresh to update accounts, balance is already handled in UI
            setRefresh(prev => !prev)
            setIsWithdrawCryptoOpen(false);
            setShowConfirmModal(false);
            setAmount("");
            
            // Fetch updated user data for accounts after a delay
            setTimeout(() => {
              dispatch(getUserdata());
              // Trigger another refresh to update the AddedAccounts component
              setRefresh(prev => !prev);
            }, 1500);
          }
          else {
            setRefresh(prev => !prev)
            setIsWithdrawCryptoOpen(false);
            setShowConfirmModal(false);
            setAmount("");
            
            // Still fetch user data to ensure consistency
            setTimeout(() => {
              dispatch(getUserdata());
              setRefresh(prev => !prev);
            }, 1500);
          }
        },
      })
    );
  };

  if (!isWithdrawCryptoOpen) return null;

  return (
    <>
      {/* Main Modal */}
      <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
        <div className="bg-white rounded-xl shadow-lg w-full max-w-md p-6 relative">
          <div className="flex justify-between items-center mb-4">
            <h2 className="text-xl font-semibold">Withdraw Crypto</h2>

          </div>

          <form onSubmit={handleSubmit} className="space-y-5">
            {/* Wallet Address */}
            <div>
              <label className="block text-sm font-medium mb-1">
                Wallet Address (USDT).*
              </label>
              <input
                name="walletAddress"

                className={`w-full border rounded px-3 py-2 focus:outline-none focus:ring ${errors.walletAddress ? "border-red-500" : "border-gray-300"
                  }`}

                value={formData.walletAddress}
                onChange={handleChange}
              />
              {errors.walletAddress && (
                <p className="text-sm text-red-500 mt-1">{errors.walletAddress}</p>
              )}
            </div>

            {/* Chain Selection */}
            <div>
              <label className="block text-sm font-medium mb-1">Chain</label>
              <div className="flex gap-4">
                {["TRC20", "ERC20"].map((item) => (
                  <label
                    key={item}
                    className={`cursor-pointer flex items-center px-4 py-2 rounded-md border ${formData.chain === item
                      ? "bg-green-100 border-green-500 text-green-700"
                      : "border-gray-300"
                      }`}
                  >
                    <input
                      type="radio"
                      name="chain"
                      value={item}
                      checked={formData.chain === item}
                      onChange={handleChange}
                      className="mr-2"
                    />
                    {item}
                  </label>
                ))}
              </div>
            </div>

            {/* Amount */}
            <div>
              <label className="block text-sm font-medium mb-1">Amount</label>
              <div className="flex items-center border rounded-md overflow-hidden">
                <span className="bg-gray-100 px-3 text-sm">₮</span>
                <input
                  name="amount"
                  placeholder="Enter amount"
                  className={`w-full px-3 py-2 outline-none ${errors.amount ? "border-red-500" : "border-none"
                    }`}
                  value={amount}
                  onChange={handleChange}
                />
                <span className="bg-gray-100 px-3 text-sm">USDT</span>
              </div>
              {errors.amount && (
                <p className="text-sm text-red-500 mt-1">{errors.amount}</p>
              )}
            </div>

            {/* Submit Button */}
            <div className="mt-6 flex justify-center space-x-4">
              <button
                type="submit"
                className="bg-green-600 hover:bg-green-700 text-white px-6 py-2 rounded font-semibold focus:outline-none focus:ring"
              >
                Submit
              </button>

              <button
                type="button"
                onClick={() => setIsWithdrawCryptoOpen(false)}
                className="bg-gray-300 hover:bg-gray-400 text-gray-700 px-6 py-2 rounded font-semibold focus:outline-none focus:ring"
              >
                Cancel
              </button>
            </div>
          </form>
        </div>
      </div>

      {/* Confirmation Modal */}
      {showConfirmModal && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
          onClick={() => setShowConfirmModal(false)} // close when clicking outside
        >
          <div
            className="bg-white rounded-lg shadow-xl w-full max-w-sm p-6 text-center relative"
            onClick={(e) => e.stopPropagation()} // prevent close when clicking inside modal
          >
            {/* Cross Button */}
            <button
              className="absolute top-2 right-2 text-gray-500 hover:text-gray-800 text-xl"
              onClick={() => setShowConfirmModal(false)}
            >
              &times;
            </button>

            <h3 className="text-lg font-semibold mb-4">
              Do you want to save this address for future use?
            </h3>
            <div className="flex justify-center gap-4">
              <button
                onClick={() => handleFinalSubmit(true)}
                className="bg-emerald-500 hover:bg-emerald-600 text-white px-6 py-2.5 rounded-full font-medium shadow-md transition duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-emerald-400"
              >
                Yes
              </button>
              <button
                onClick={() => handleFinalSubmit(false)}
                className="bg-gray-200 hover:bg-gray-300 text-gray-800 px-6 py-2.5 rounded-full font-medium shadow-md transition duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-gray-300"
              >
                No
              </button>
            </div>
          </div>
        </div>
      )}

    </>
  );
};